import { render } from "./FeatureNotAvailable.vue?vue&type=template&id=928f5250&scoped=true"
import script from "./FeatureNotAvailable.vue?vue&type=script&lang=js"
export * from "./FeatureNotAvailable.vue?vue&type=script&lang=js"

import "./FeatureNotAvailable.vue?vue&type=style&index=0&id=928f5250&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-928f5250"]])

export default __exports__